import { z } from 'zod'

export const schema = z.object({
  update_type: z.union([
    z.literal('create'),
    z.literal('complete'),
    z.literal('override'),
    z.literal('replace'),
  ]),
  files: z.instanceof(FileList).refine((v) => v.length > 0),
})

export type SchemaType = z.infer<typeof schema>
